import styled from 'styled-components';

import { MOBILE } from '../../theme/tokens';

/** Full-bleed content column — spans the whole content area (like the Players / Home
 *  dashboards), not content-capped like the Settings page. */
export const Page = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${MOBILE} {
    gap: 14px;
  }
`;
